import { render, staticRenderFns } from "./LeftBarSubButtons.vue?vue&type=template&id=49c59ae8&scoped=true"
import script from "./LeftBarSubButtons.vue?vue&type=script&lang=js"
export * from "./LeftBarSubButtons.vue?vue&type=script&lang=js"
import style0 from "./LeftBarSubButtons.vue?vue&type=style&index=0&id=49c59ae8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c59ae8",
  null
  
)

export default component.exports